// @flow
import {observable} from 'mobx'

export type NavButton = {
  label: string,
  background: string,
  onClick: () => void
}

type Store = {
  buttonList: NavButton[],
  clearButtonList: () => void,
  setButtonList: (buttons:NavButton[]) => void
}

const store:Store = observable(({
  buttonList: [],
  clearButtonList(){
    store.buttonList = []
  },
  setButtonList(buttons){
    store.buttonList = buttons
  }
}:Store))

export default store

window.navbar = store


// WEBPACK FOOTER //
// ./src/stores/navbar.js